// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield20: FC<CheckShield20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m9.125 12.938 4.583-4.605-1.062-1.062-3.521 3.542-1.77-1.771-1.063 1.062 2.833 2.834ZM10 18c-1.875-.458-3.427-1.52-4.656-3.184C4.114 13.15 3.5 11.303 3.5 9.27V4.5L10 2l6.5 2.5v4.77c0 2.033-.615 3.881-1.844 5.546C13.427 16.48 11.875 17.542 10 18Zm0-1.563c1.444-.447 2.639-1.343 3.583-2.687A7.612 7.612 0 0 0 15 9.27V5.52l-5-1.916-5 1.917v3.75c0 1.642.472 3.135 1.417 4.479.944 1.344 2.139 2.24 3.583 2.688Z" />
        </svg>
    );
};

export default CheckShield20;
